export const ConditionalMaterialField = ({ fieldName, fieldId, allowedCodes, children }) => {
  const { [fieldName]: field } = allowedCodes || {}
  return field && field.indexOf(parseInt(fieldId, 10)) !== -1 ? children : null
}
